import FolderOpenIcon from '@cp/src/assets/images/icons/FolderOpenIcon';
import { Typography } from '@navi/web-ui/lib/primitives';

const SearchQueryNotFound = () => {
  return (
    <div>
      <FolderOpenIcon />
      <Typography variant="p3" color="var(--navi-color-gray-c3">
        No results found!
      </Typography>
    </div>
  );
};

export default SearchQueryNotFound;
